import React, { useEffect, useState } from "react";
import { ExternalLink, LifeBuoy, Server, Mail } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Disclaimer } from "@/components/common";

export default function Support() {
    const [links, setLinks] = useState([]);
    useEffect(() => { api.get("/system-links").then((r) => setLinks(r.data)).catch(() => {}); }, []);

    return (
        <div className="space-y-6" data-testid="support-page">
            <PageHeader title="Suporte" subtitle="Ajuda e atalhos para os sistemas oficiais da ANM." />

            <div className="bg-white border border-slate-200 rounded-md p-6 shadow-sm">
                <div className="flex items-center gap-2 mb-2"><Server className="w-5 h-5 text-petroleum" /><h2 className="font-heading font-bold text-slate-800">Sistemas ANM</h2></div>
                <p className="text-sm text-slate-500 mb-4">Atalhos oficiais. Os links abrem os portais externos da ANM / gov.br.</p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {links.map((l) => (
                        <a key={l.id} href={l.url} target="_blank" rel="noreferrer" data-testid={`system-link-${l.name}`}
                            className="border border-slate-200 rounded-md p-4 hover:border-petroleum/40 hover:shadow-sm transition-all group">
                            <div className="flex items-center justify-between">
                                <span className="font-heading font-bold text-slate-800">{l.name}</span>
                                <ExternalLink className="w-4 h-4 text-slate-400 group-hover:text-petroleum transition-colors" />
                            </div>
                            <p className="text-xs text-slate-500 mt-1">{l.description}</p>
                        </a>
                    ))}
                </div>
            </div>

            <div className="bg-white border border-slate-200 rounded-md p-6 shadow-sm">
                <div className="flex items-center gap-2 mb-2"><LifeBuoy className="w-5 h-5 text-petroleum" /><h2 className="font-heading font-bold text-slate-800">Fale conosco</h2></div>
                <p className="text-sm text-slate-500">Precisa de ajuda com a plataforma? Nossa equipe está à disposição.</p>
                <a href="mailto:suporte@anmmanager.com.br" className="mt-3 inline-flex items-center gap-2 text-petroleum hover:text-petroleumHover font-semibold text-sm"><Mail className="w-4 h-4" /> suporte@anmmanager.com.br</a>
            </div>

            <Disclaimer />
        </div>
    );
}
